import { useContext } from 'react'
import { Routes, Route } from 'react-router-dom'
import { DataProvider } from './store/ContextProvider'
import { Login } from './pages/Authentications/Login'

import CandidateDashboard from './pages/Candidate Portal/Dashboard'
import EmployerDashboard from './pages/Employer Portal/Dashboard'
import AdminDashboard from './pages/Admin Portal/Dashboard'
import Job from './pages/Candidate Portal/Job'
import JobList from './pages/Candidate Portal/JobList'
import { Notification } from './pages/Notification'
import { Home } from './pages/Public/Home'
import { RaiseTicket } from "./pages/Tickets/RaiseTickets"
import { Tickets } from "./pages/Tickets/Tickets"
import { ViewTickets } from "./pages/Tickets/ViewTicket"
import { Signup } from './pages/Authentications/Signup'
import { ForgotPassword } from './pages/Authentications/ForgotPassword'
import { ResetPassword } from './pages/Authentications/ResetPassword'

import { SessionLogs } from './pages/Admin Portal/SessionLogs/SessionLogs';
import { LogHistory } from './pages/Admin Portal/SessionLogs/LogHistory';
import SessionHistory from './pages/Admin Portal/SessionLogs/SessionHistory';

import Employer from './pages/Employer'
import PageNotFound from './pages/NotFound'
import NotAuthorized from './pages/NotAuthorized'

import CreateJob from './pages/Employer Portal/Jobs/CreateJob';
import JobUpdate from './pages/Employer Portal/Jobs/JobUpdate';
import EmployerApplications from './pages/Employer Portal/Jobs/JobApplications';


import ViewCandidate from './pages/ViewCandidate';
import ListCandidate from './pages/Candidate Search/ListCandidate';
import AdvancedSearch from './pages/Candidate Search/AdvancedSearch';

import ImportCandidate from './pages/Admin Portal/ImportCandidate';
import ResumeProcess from './pages/Admin Portal/ResumeProcess';
import ImportInfo from './pages/Admin Portal/ImportInfo';
import { AccountRouter } from './pages/Candidate Portal/AccountRouter'
import MyAccount from './pages/Candidate Portal/ViewAccount'
import PrivacyPolicyModal from './components/PrivacyPolicyModal'
import { AboutPage } from './pages/Public/About'
import { WorkPage } from './pages/Public/Work'
import { ExploreIndustries } from './pages/Public/Explore'


import ListUsers from './pages/Admin Portal/Users/ListUsers'
import EditUsers from './pages/Admin Portal/Users/EditUsers'
import ViewUser from './pages/Admin Portal/Users/ViewUser'
import SignUpEmployer from './pages/Admin Portal/Users/SignUpEmployer'
import ChangePassword from './pages/Authentications/ChangePassword'
import Logout from './pages/Authentications/Logout'
import PrivacyPolicy from './pages/PrivacyPolicyModal'
import TermsAndCondition from './pages/TermsCondition'
import Jobs from './components/Candidate Portal/Job'
import ViewNewcomer from './pages/ViewNewcomer'
import { Resume } from './components/Candidate Portal/Account Tabs/Resume'
import ViewJobs from './pages/Employer Portal/Jobs/ViewJobs'
import PrepareResume from './pages/Candidate Portal/PrepareResume'

// import ResumeUploader from './pages/Admin Portal/ResumeParser'

function Router() {

    const { isAuth, currentUser } = useContext(DataProvider)

    const renderHomepage = () => {
        if (isAuth) {
            if (currentUser.role === 'job-seeker') {
                return <CandidateDashboard />
            }
            else if (currentUser.role === "employer") {
                return <EmployerDashboard />
            }
            else if (currentUser.role === "admin") {
                return <AdminDashboard />
            }
            else {
                return <Home/>
            }
        }
        else return <Home />
    }

    const employerRouter = (Component) => {
        if (isAuth) {
            if (currentUser.role === "employer") {
                return <Component />
            }
            else return <NotAuthorized />
        }
        else return <Login />
    }

    const recruitmentRouter = (Component) => {
        if (isAuth) {
            if (currentUser.role === "employer" || currentUser.role === "admin") {
                return <Component />
            }
            else return <NotAuthorized />
        }
        else return <Login />
    }

    const adminRouter = (Component) => {
        if (isAuth) {
            if (currentUser.role === "admin") {
                return <Component />
            }
            else return <NotAuthorized />
        }
        else return <Login />
    }

    return (
        <div className='min-h-[65vh]'>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/dashboard" element={<CandidateDashboard />} />
                <Route path="/employer-dashboard" element={<EmployerDashboard />} />
                <Route path="/admin-dashboard" element={<AdminDashboard />} />
                <Route path='/about' element={<AboutPage />} />
                <Route path='/works' element={<WorkPage />} />
                <Route path='/explore' element={<ExploreIndustries />} />
                <Route path="/login" element={isAuth ? renderHomepage() : <Login />} />
                <Route path="/logout" element={isAuth ? <Logout /> : <Home />} />
                <Route path="/signup" element={isAuth ? renderHomepage() : <Signup />} />
                <Route path="/forgotpassword" element={isAuth ? renderHomepage() : <ForgotPassword />} />
                <Route path="/resetpassword" element={<ResetPassword />} />
                <Route path="/change-password" element={isAuth ? <ChangePassword /> : <Login />} />
                <Route path='/privacy-policy' element={<PrivacyPolicy />} />
                <Route path='/terms' element={<TermsAndCondition />} />

                <Route path="/account" element={<MyAccount />} />

                <Route path="/update-account/:page" element={isAuth ? <AccountRouter /> : <Login />} />
                <Route path='/search-jobs' element={<CandidateDashboard />} />


                <Route path="/job/:id" element={<Job />} />
                <Route path='/jobs/:slug' element={<Jobs />} />
                <Route path="/saved-jobs" element={<JobList page={"saved"} />} />
                <Route path="/applied-jobs" element={<JobList page={"applied"} />} />

                <Route path='/notification' element={isAuth ? <Notification /> : <Login />} />

                <Route path='/raise-ticket' element={isAuth ? <RaiseTicket /> : <Login />} />
                <Route path='/tickets' element={isAuth ? <Tickets /> : <Login />} />
                <Route path='/ticket/:id' element={isAuth ? <ViewTickets /> : <Login />} />

                <Route path='/session-logs' element={isAuth ? <SessionLogs /> : '*'} />
                <Route path="/fetch-log-history/:id" element={isAuth ? <LogHistory /> : '*'} />
                <Route path="/session-history" element={isAuth ? <SessionHistory /> : '*'} />

                <Route path="/employer/:id" element={<Employer />} />


                <Route path='/create-job' element={employerRouter(CreateJob)} />
                <Route path='/update-job/:id' element={recruitmentRouter(JobUpdate)} />
                <Route path='/job-applications' element={employerRouter(EmployerApplications)} />
                <Route path='/list-jobs' element={isAuth ? <ViewJobs/> : <Login />} />

                <Route path='/list-candidates' element={recruitmentRouter(ListCandidate)} />
                <Route path='/candidate/:id' element={recruitmentRouter(ViewCandidate)} />
                <Route path='/pro-search' element={recruitmentRouter(AdvancedSearch)} />

                <Route path='/view-newcomer' element={isAuth ? <ViewNewcomer /> : <Login />} />
                {/* <Route path='/resume-parser' element={adminRouter(ResumeUploader)} />  */}
                <Route path='/import-candidate' element={adminRouter(ImportCandidate)} />
                <Route path='/import-resume' element={adminRouter(ResumeProcess)} />
                <Route path='/import-info' element={adminRouter(ImportInfo)} />

                <Route path='/list-users' element={adminRouter(ListUsers)} />
                <Route path='/edit-user/:id' element={adminRouter(EditUsers)} />
                <Route path='/user/:id' element={adminRouter(ViewUser)} />
                <Route path='/signUpEmployer' element={adminRouter(SignUpEmployer)} />

                <Route path='/privacy policy' element={<PrivacyPolicyModal />} />

                <Route path='/upload-resume' element={isAuth ? <Resume /> : <Login />} />
                <Route path='/browse-jobs' element={!isAuth && <CandidateDashboard />} />
                <Route path='/resume-creator' element={<PrepareResume/>} />

                <Route path="*" element={<PageNotFound />} />
            </Routes>
        </div>
    )
}

export default Router